import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./DefaultProject.scss";
import Axios from "axios-https-proxy-fix";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import translator from "../../../utils/translator";
import { Dropdown } from "semantic-ui-react";

export class DefaultProject extends Component {
	static propTypes = {
		prop: PropTypes
	};
	state = {
		projectName: "",
		warehouse: "",
		account_name: "",
		account_id: "",
		shipTo: "",
		address: "",
		city: "",
		province: "",
		postal: "",
		projectedBudget: 0.00,
		roughInDate: null,
		closingInDate: null,
		actingAgent: false,
		// we will use this to update the default project
		id: "",
		//below line is used for error message and success message
		message: "",

		response: {},
		allAccounts: {},
		allShipTos: {},
		accountQuery: ""
	};

	async componentDidMount() {
		let getDefaultProjectForThisTrendUserAPIUrl =
			this.props.APIUrl + "/projects/fetch-default";
		let data = {
			trendId: localStorage.getItem("trendId")
		};
		let getDefaultProjectForThisTrendUserAPIResponse = await Axios.post(
			getDefaultProjectForThisTrendUserAPIUrl,
			data
		);

		let defaultProjectInformation =
			getDefaultProjectForThisTrendUserAPIResponse.data.getDefaultProjectForTrendUser;
		if(!!defaultProjectInformation) {
			this.setState({
				projectName: defaultProjectInformation.title,
				warehouse: defaultProjectInformation.warehouse,
				account_id: "" + defaultProjectInformation.account_id,
				account_name: defaultProjectInformation.account_name,
				shipTo: defaultProjectInformation.ship_to,
				address: defaultProjectInformation.address,
				city: defaultProjectInformation.city,
				province: defaultProjectInformation.province,
				postal: defaultProjectInformation.postal,
				projectedBudget: defaultProjectInformation.budget,
				roughInDate: defaultProjectInformation.rough_in_date,
				closingInDate: defaultProjectInformation.closing_in_date,
				actingAgent: defaultProjectInformation.acting_agent,
				id: defaultProjectInformation.id,
				allAccounts: defaultProjectInformation.account_id
					? {[defaultProjectInformation.account_id]: {Name: defaultProjectInformation.account_name, CustomerNumber: defaultProjectInformation.account_id}}
					: {}
			});
			if(defaultProjectInformation.account_id) {
				await this.getShipTos(defaultProjectInformation.account_id, defaultProjectInformation.warehouse);
			}
		}
	}

	callAjax = async (route, data) => {
		data.trendId = localStorage.getItem("trendId");
		data.token = localStorage.getItem("token");

		let APIResponse = await Axios.post(this.props.APIUrl + route, data);

		if (APIResponse.data.hasOwnProperty("error")) {
			this.setState({ response: { error: APIResponse.data.error } });
			return false;
		}
		this.setState({ response: {} });
		return APIResponse.data;
	};

	getAccounts = async query => {
		this.setState({ response: { loadingbar: translator("Misc", "loading_label") } });
		let route = "/emco_settings/search-accounts";
		let response = await this.callAjax(route, { q: query });
		if (!response) return;
		if (!response.hasOwnProperty("data")) this.setState({ allAccounts: {} });
		else this.setState({ allAccounts: this.arrayToObject(response.data, "CustomerNumber") });
	};

	getShipTos = async (account, warehouse) => {
		this.setState({ response: { loadingbar: translator("Misc", "loading_label") } });
		let route = "/emco_settings/search-shiptos";
		let response = await this.callAjax(route, { account_id: account, warehouse });
		if (!response) return;
		if (!response.hasOwnProperty("data")) this.setState({ allShipTos: {} });
		else this.setState({ allShipTos: this.arrayToObject(response.data, "ShipTo") });
	};

	arrayToObject = (arr, key) => arr.reduce((obj, item) => ({ ...obj, [item[key]]: item }), {});

	searchAccounts = query => {
		window.clearTimeout(this.state.searchTimeout);
		this.setState({
			searchTimeout: window.setTimeout(this.getAccounts, 500, query)
		});
	};

	setAccount = account => {
		if(!account) {
			this.setState({ account_id: "", account_name: "", allShipTos: {}, shipTo: "" });
		} else {
			this.setState({ account_id: account, account_name: this.state.allAccounts[account].Name, allShipTos: {}, shipTo: "" });
			this.getShipTos(account, this.state.warehouse);
		}
	};

	renderResponse = response => {
		if (Object.keys(response).length === 0) return null;
		let key = "error";
		if (response.hasOwnProperty("success")) key = "success";
		if (response.hasOwnProperty("loadingbar")) key = "loadingbar";
		let cardClass = "card user-profile-card response-" + key;
		return (
			<div className={cardClass}>
				<div class="card-body">{response[key]}</div>
			</div>
		);
	};

	updateDefaultProject = async () => {
		let updateDefaultProjectInformationAPIUrl =
			this.props.APIUrl + "/projects/update-default";

		// make sure the keys are the same name as the database table because our backend is using a certain function that requires it to be this way
		let data = {
			title: this.state.projectName,
			warehouse: this.state.warehouse,
			account_id: this.state.account_id,
			account_name: this.state.account_name,
			ship_to: this.state.shipTo,
			address: this.state.address,
			city: this.state.city,
			province: this.state.province,
			postal: this.state.postal,
			budget: this.state.projectedBudget,
			rough_in_date: this.state.roughInDate,
			closing_in_date: this.state.closingInDate,
			acting_agent: this.state.actingAgent,
			id: this.state.id,
			language: this.props.selected_language,
			consultant_id: localStorage.getItem("trendId")
		};

		let updateDefaultProjectInformationAPIResponse = await Axios.post(
			updateDefaultProjectInformationAPIUrl,
			data
		);

		this.setState({ response: { success: updateDefaultProjectInformationAPIResponse.data.message }});
	};

	render() {
		let state = this.state;
		let accountOptions = Object.entries(state.allAccounts).map(account => ({ value: account[0], text: account[1].Name + ' | ' + account[1].CustomerNumber }));
		let shiptoOptions = Object.entries(state.allShipTos).map(shipto => ({
			value: shipto[0],
			text: (
				<div class="dropdown-shipto">
					<span class="dropdown-shipto-shipto">{shipto[1].ShipTo}</span>
					<span class="dropdown-shipto-name">{" "}{shipto[1].Name}</span>
					<span class="dropdown-shipto-address1">{" "}{shipto[1].Address1}</span>
					<span class="dropdown-shipto-address2">{" "}{shipto[1].Address2}</span>
				</div>
			)
		}));
		accountOptions.unshift({
			value: "",
			text: translator("Admin Pricing", "none_label")
		});
		shiptoOptions.unshift({
			value: "",
			text: (
				<div class="dropdown-shipto">
					<span class="dropdown-shipto-shipto">{translator("Admin Pricing", "none_label")}</span>
				</div>
			)
		});

		let main = (
			<>
				{this.state.message}
				<div class="card user-profile-card">
					<div class="card-body">
						<form>
							<div class="form-group">
								<h2 style={{ color: "#16448e" }}>{translator("Admin Default Project", "page_heading")}</h2>
							</div>
							<div class="form-group">
								<label>{translator("Admin Default Project", "project_name_label")}</label>
								<input
									type="text"
									class="form-control default-project-setting-form"
									placeholder={translator("Project Setup", "enter_name_placeholder")}
									value={this.state.projectName}
									onChange={event =>
										this.setState({ projectName: event.target.value })
									}
								/>
							</div>
							<div class="form-group">
								<label>{translator("Admin Default Project", "warehouse_label")}</label>
								<input
									type="text"
									class="form-control default-project-warehouse-setting-form"
									placeholder={translator("Project Setup", "enter_address_placeholder")}
									value={this.state.warehouse}
									onChange={event =>
										this.setState({ warehouse: event.target.value })
									}
								/>
							</div>

							<div className="form-group">
								<label>{translator("Misc", "account_label")}</label>
								<div class="default-project-warehouse-setting-form">
									<Dropdown
										fluid
										search={(options, query) => options}
										selection
										placeholder={translator("Admin Picturebook", "account_placeholder")}
										options={accountOptions}
										onSearchChange={(e, d) => {
											this.searchAccounts(d.searchQuery);
										}}
										onChange={(e, d) => this.setAccount(d.value)}
										value={this.state.account_id}
									/>
								</div>
							</div>
						<div className="form-group">
							<label>{translator("Project Setup", "ship_to_label")}</label>
							<div class="default-project-warehouse-setting-form">
									<Dropdown fluid selection options={shiptoOptions} value={this.state.shipTo} onChange={(e, d) => this.setState({ shipTo: d.value })} />
								</div>
							</div>
							<div class="form-group">
							<label>{translator("Admin Default Project", "address_label")}</label>
							<input
								type="text"
								class="form-control default-project-setting-form"
								placeholder={translator("Project Setup", "enter_address_placeholder")}
								value={this.state.address}
									onChange={event =>
										this.setState({ address: event.target.value })
									}
								/>
							</div>
							<div class="form-group">
								<label>{translator("Admin Default Project", "city_label")}</label>
								<input
									type="text"
									class="form-control default-project-setting-form"
									placeholder={translator("Project Setup", "enter_city_placeholder")}
									value={this.state.city}
									onChange={event => this.setState({ city: event.target.value })}
								/>
							</div>
							<div class="form-group">
								<label>{translator("Admin Default Project", "province_label")}</label>
								<select
									class="dropdown-toggle form-control default-project-setting-form"
									type="button"
									id="dropdownMenuButton"
									value={this.state.province}
									onChange={event =>
										this.setState({ province: event.target.value })
									}
								>
									<option value="">{translator("Admin Default Project", "select_province")} &#8964;</option>
									<option value="AB">{translator("Misc", "province_ab")}</option>
									<option value="BC">{translator("Misc", "province_bc")}</option>
									<option value="MB">{translator("Misc", "province_mb")}</option>
									<option value="NB">{translator("Misc", "province_nb")}</option>
									<option value="NL">{translator("Misc", "province_nl")}</option>
									<option value="NT">{translator("Misc", "province_nt")}</option>
									<option value="NS">{translator("Misc", "province_ns")}</option>
									<option value="NU">{translator("Misc", "province_nu")}</option>
									<option value="ON">{translator("Misc", "province_on")}</option>
									<option value="PE">{translator("Misc", "province_pe")}</option>
									<option value="QC">{translator("Misc", "province_qc")}</option>
									<option value="SK">{translator("Misc", "province_sk")}</option>
								<option value="YT">{translator("Misc", "province_yt")}</option>
							</select>
						</div>
						<div class="form-group">
							<label>{translator("Admin Default Project", "postal_label")}</label>
							<input
								type="text"
								class="form-control default-project-setting-form"
								placeholder={translator("Project Setup", "enter_postal_placeholder")}
								value={this.state.postal}
								onChange={event =>
									this.setState({ postal: event.target.value })
								}
							/>
						</div>
						<button
							onClick={this.updateDefaultProject}
							type="button"
								class="btn btn-primary"
							>
								{translator("Admin Default Project", "submit_btn")}
							</button>
						</form>
					</div>
				</div>
			{Object.keys(state.response).length ? this.renderResponse(state.response) : null}
		</>
	);
	return <SettingsWrapper header={translator("Admin Default Project", "page_title")} main={main} />;
}
}const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	selected_language: state.selected_language
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultProject);
